$giper_baza_app_stat_chart $mol_chart
	graphs /
		^ metrics /$mol_plot_graph
		<= Zones $mol_plot_fill
			Sample null
			series_x <= zones_x /
			series_y <= zones_y /
				0
				100
				100
				0
		<= Ruler_vert $mol_plot_ruler_vert
		<= Marks $mol_plot_mark_cross
			labels <= times /
			graphs <= metrics
